/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC, useEffect} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage} from '../modules/auth'
import {App} from '../App'
import {useDispatch} from 'react-redux'
import useAuth from '../hooks/useAuth'
import {clearToken, setAdmin} from '../../redux/reducers/auth.slice'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const dispatch = useDispatch()

  const {getAdmin} = useAuth()
  useEffect(() => {
    const init = async () => {
      try {
        const {data, status} = await getAdmin()

        console.log(data, 'data-admin')

        if (status === 200) {
          const d = {
            ...data,
            name: data?.name || data?.username,
          }
          dispatch(setAdmin(d))
        } else {
          dispatch(clearToken())
          if (window.location.pathname !== '/auth/login') {
            window.location.href = '/auth/login'
          }
        }
      } catch (error: any) {
        dispatch(clearToken())
      }
    }

    if (!localStorage.getItem('accessToken')) {
      if (window.location.pathname !== '/auth/login') {
        window.location.href = '/auth/login'
      }
    } else {
      init()
    }
  }, [])
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          {localStorage.getItem('accessToken') ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/dashboard' />} />
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
